import { ensureDefined, isDefined } from '@e-socna/utils';

import type {
  ResolverParameters,
  ResolverResult,
} from '../types/resolvers.type';

import { DISTANCE_UNAVAILABLE_PLACEHOLDER } from './constants/distance.constant';
import { useMissionQuickAccess } from './hooks/useMissionQuickAccess.hook';

export const useSIGDistanceExacteMissionAgenceEnKmAuPlusRapide = (
  parameters: ResolverParameters,
): ResolverResult<number | string> => {
  const quickAccess = useMissionQuickAccess(parameters);

  if (!quickAccess.isSuccess) {
    return {
      ...quickAccess,
      data: undefined,
    };
  }

  const { data } = ensureDefined({
    data: quickAccess.data,
  });

  const {
    distances: { fastestFromQuotationEmitterInKm },
  } = data;

  if (!isDefined(fastestFromQuotationEmitterInKm)) {
    return {
      data: { generated: DISTANCE_UNAVAILABLE_PLACEHOLDER },
      error: null,
      isLoading: false,
      isSuccess: true,
    };
  }

  return {
    data: { generated: fastestFromQuotationEmitterInKm },
    error: null,
    isLoading: false,
    isSuccess: true,
  };
};
